import { HStack, IconButton, Image, StackProps } from '@chakra-ui/react';
import * as React from 'react';

import { ImageFallback } from '@/imports/ui/chakra/components/ImageFallback';
import { XIcon } from '@/imports/ui/chakra/feather';

export const ImageUploadPreview: React.FC<
  {
    onClickImage?: (value: { imageId: string } | { videoId: string }) => void;
    resourcesSyncedWithDraft: (
      | {
          imageId: string;
          url?: string;
        }
      | {
          videoId: string;
          url?: string;
        }
    )[];
  } & StackProps
> = ({ onClickImage, resourcesSyncedWithDraft, ...stackProps }) => {
  return !!resourcesSyncedWithDraft?.length ? (
    <HStack spacing="2" overflowX="scroll" {...stackProps}>
      {resourcesSyncedWithDraft.map((resource) => {
        return (
          <HStack
            key={resource.url}
            alignItems="start"
            flexShrink="0"
            spacing="1"
          >
            <Image
              h={20}
              w={28}
              borderRadius="xl"
              objectFit="cover"
              src={resource.url}
              fallback={<ImageFallback h={20} w={28} borderRadius="xl" />}
              flexShrink="0"
              alt=""
            />
            <IconButton
              size="xs"
              colorScheme="gray"
              borderRadius="full"
              icon={<XIcon />}
              aria-label="Remove Image"
              onClick={() => onClickImage && onClickImage(resource)}
            />
          </HStack>
        );
      })}
    </HStack>
  ) : null;
};
